import { CoordinateModel } from './coordinate.model';

export interface ProductModel {
    additionalinfo?: string[];
    address: string;
    area: number[][];
    attributeshortcuts: string;
    availabilities?: Array<{
        weeks: number[];
        year: number;
    }>;
    basketduration: number;
    basketstate: number | string;
    city: string;
    communicationspaces: string[];
    description: string | null;
    durationpossible: number[];
    enddate: Date | null;
    format: string;
    formatcode: string;
    latitude: number | string;
    longitude: number | string;
    mediacount: number;
    mediainfo: {
        [key: string]: string | number | unknown;
        nummer: number;
    };
    name: string;
    pricedays: number;
    pricefordates: Array<{
        days: number;
        price: number;
        week: number;
        year: number;
    }>;
    priceinformation: {
        [key: string]: string | number | unknown;
        pricedays: number;
        priceinformation: string;
        pricelabel: string;
        pricelabeltype: number;
        standardprice: number;
    };
    productphotopath: string;
    producttype: string;
    producturn: string;
    requestofferbutton: { label: string; link: string };
    shopstate: number;
    size: number;
    spotlength: number;
    standardprice: number;
    standardpricefornextyear: number;
    startdate: Date | null;
    startingday: number;
    startweekday: number;
    subpoints: SubPoint[];
    sujetcheckinformation: { format: string; infotext: string; maxsize: number };
    tags: string[];
    validfrom: Date | null;
    validto: Date | null;
}

export interface GetProductListModel {
    bookingyear: number;
    controller?: AbortController;
    criteria: {
        attribute: string[];
        basket?: number;
        basketreference?: string;
        category: string[];
        commspace: string[];
        coordinate: CoordinateModel[];
        distribution: string[];
        duration: Array<string | number>;
        format: string[];
        individualproducts: string[];
        pricerange?: Array<string | number>;
        region: string[];
        restrictions?: Array<string | number>;
        type: string[];
    };
    delivertotalcount?: number;
    group: string[];
    limit: string | number;
    offset: string | number;
    sort: Array<{ column: string; direction: number }>;
    types?: string[];
}

export interface GetProductModel {
    bookingyear?: number;
    date?: string | string[];
    duration?: string | string[];
    urn: string | string[];
}

export interface GetProductDetailsModel {
    bookingyear?: number;
    date?: string | string[];
    urn: string;
}

export interface NeighborsProductsModel {
    description: string;
    distance?: string | number;
    locationparameter: string;
    pictureurl: string;
    title: string;
    urn: string;
}

export interface DetailProductModel {
    area: number[][];
    formatcode: string;
    latitude: number | string;
    location: Array<{
        iinfo: { icon: boolean | null; link: string | undefined; text: string | undefined } | undefined;
        label: string;
        value: string | number;
    }> | null;
    longitude: number | string;
    maininfo: Array<{
        iinfo: { icon: boolean | null; link: string | undefined; text: string | undefined } | undefined;
        label: string;
        value: string | number;
    }> | null;
    maplink: string;
    number: number;
    productnumber: number;
    pricedays: number;
    pricedetails: Array<{ label: string; value: string; values: string[] }> | null;
    priceinformation: {
        [key: string]: string | number | unknown;
        pricedays: number;
        priceinformation: string;
        pricelabel: string;
        pricelabeltype: number;
        standardprice: number;
    };
    prices: Array<{ days: string | number; price: string | number; subline: string }> | null;
    pricetabletext: Array<{ href: string; text: string; title: string }> | null;
    productimage: string;
    productimages: string[];
    producturn: string;
    requestofferbutton: { label: string; link: string };
    singlemaplink: string;
    standardprice: number | string;
    subpoints: SubPoint[];
    sujetcheckinformation: { [key: string]: string | number };
    technicalinfo: { data: Array<{ href: string; label: string; value: string }>; productionlink: string | null } | null;
    title: string;
    type: ProductTypes;
    validfrom: Date | null;
    validto: Date | null;
}

export enum ProductTypes {
    NET = 'net',
    SINGLE_CLASSIC = 'singleclassic',
    DIGITAL = 'digital',
    TRAFFIC = 'traffic',
    TRAFFIC_OUT_DOOR = 'trafficoutdoor',
}

export interface SubPoint {
    format: string;
    image: string;
    name: string;
    number: number;
    urn: string;
    x: number;
    y: number;
}
